<script lang="ts" setup>
import type { IProps } from './UiBox.types'

defineProps<IProps>()
</script>

<template>
  <article class="box">
    <div class="box__header">
      <span
        v-if="box.id"
        class="box__header_id"
      >
        {{ box.id }}
      </span>

      <h3>
        {{ box.title }}
      </h3>
    </div>

    <div class="box__image">
      <img
        v-if="box.image"
        :src="box.image.url"
      >
    </div>

    <div class="box__text">
      <p>
        {{ box.text }}
      </p>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.box {
  min-width: 26.9rem;
  width: 100%;
  overflow: hidden;
  background-color: $white;
  border-radius: 1.6rem;

  @include atM {
    min-width: auto;
  }

  &__header {
    display: flex;
    align-items: center;
    padding: 1.8rem 3.2rem;
    background-color: $purple-100;

    &_id {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.8rem;
      height: 4.8rem;
      margin-right: 1.6rem;
      font-weight: 500;
      font-size: 2.4rem;
      line-height: 3.2rem;
      background-color: $white;
      border-radius: 50%;
    }

    h3 {
      font-weight: 500;
      font-size: 2rem;
      line-height: 2.8rem;
    }

    @include atXL {
      padding: 2.4rem 3.2rem;

      h3 {
        font-size: 2.4rem;
        line-height: 3.2rem;
      }
    }
  }

  &__image {
    width: 100%;
    height: 12rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    @include atXL {
      height: 15rem;
    }
  }

  &__text {
    padding: 1.6rem 3.2rem 2.4rem 3.2rem;
    border: 0.2rem solid $gray-200;
    border-bottom-right-radius: 1.6rem;
    border-bottom-left-radius: 1.6rem;
    p {
      font-weight: 500;
      font-size: 1.6rem;
      line-height: 2.4rem;
    }

    @include atXL {
      padding: 2.4rem 3.2rem 3.2rem 3.2rem;

      p {
        font-size: 1.8rem;
      }
    }
  }
}
</style>
